<template>
	<div>
		<el-select
			v-model="id"
			filterable
			size="small"
			remote
			allow-create
			:clearable="true"
			placeholder="请搜索"
			@change="handleChange"
			:remote-method="refreshData"
		>
			<el-option v-for="item in options" :key="item._id" :label="item.name" :value="item._id"></el-option>
		</el-select>
	</div>
</template>
<script>
import RelateInput from "@/mixins/RelateInput.js";

export default {
	mixins: [RelateInput],
	data() {
		return {
			id: ""
		};
	},
	props: {
		dataModelName: {
			type: String,
			default: "meta"
		},
		nameFields: {
			type: Array,
			default: () => {
				return ["name"];
			}
		},
		filter: {
			type: String,
			default: ""
		}
	},
	computed: {},
	created() {},
	mounted() {},
	methods: {
		handleCreateNew(name) {
			this.loadings.main = true;

			this.$axios
				.post("/curd/do_quick_create/" + this.dataModel, {
					name: name,
					filter: this.filter
				})
				.then(json => {
					this.loadings.main = false;
					this.$message({
						type: "success",
						message: "创建成功!"
					});
					this.onCreateNew(json.data.info);
				})
				.catch(json => {
					this.loadings.main = false;
					this.$message.error(json);
				});
		}
		// resetEditor(val) {
		// 	if (!val) {
		// 		return;
		// 	}
		// 	this.myValue = {};
		// 	if (!val) {
		// 		return;
		// 	}
		// 	this.id = val._id;
		// 	for (let k in val) {
		// 		this.$set(this.myValue, k, val[k]);
		// 	}
		// },
		// refreshData(query) {
		// 	this.loading = true;
		// 	this.$axios
		// 		.post("/curd/search/" + this.dataModelName, {
		// 			query: query,
		// 			kvFilter: [{ k: "filter", t: "string", v: this.filter }]
		// 		})
		// 		.then(json => {
		// 			this.loading = false;
		// 			this.options = [];
		// 			for (let i = 0; i < json.data.datas.length; i++) {
		// 				this.options.push(json.data.datas[i]);
		// 			}
		// 		})
		// 		.catch(json => {
		// 			this.loading = false;
		// 			this.$message.error(json.data.msg);
		// 		});
		// 	return [];
		// },
		// handleChange(val) {
		// 	console.log("CHANGED", typeof val);
		// 	console.log("myValue", this.myValue);
		// 	if (typeof val == "object") {
		// 		this.$emit("input", this.myValue);
		// 		this.$emit("change", this.myValue);
		// 		return;
		// 	}
		// 	if (val === "") {
		// 		//清空
		// 		this.myValue = {
		// 			_id: "",
		// 			name: ""
		// 		};
		// 		this.$emit("input", this.myValue);
		// 		this.$emit("change", this.myValue);
		// 		return;
		// 	}
		// 	//新建
		// 	this.myValue = {
		// 		name: val,
		// 		_id: ""
		// 	};
		// 	this.$confirm("确认创建" + this.myValue.name + "?", "提示", {
		// 		confirmButtonText: "确定",
		// 		cancelButtonText: "取消",
		// 		type: "warning"
		// 	})
		// 		.then(() => {
		// 			this.loading = true;
		// 			this.$axios
		// 				.post("/curd/do_quick_create/" + this.dataModelName, {
		// 					name: this.myValue.name,
		// 					filter: this.filter
		// 				})
		// 				.then(json => {
		// 					this.loading = false;
		// 					this.$message({
		// 						type: "success",
		// 						message: "创建成功!"
		// 					});
		// 					this.options.push(json.data.info);
		// 					this.$nextTick(() => {
		// 						for (let k in json.data.info) {
		// 							this.$set(this.myValue, k, json.data.info[k]);
		// 						}
		// 						this.$emit("input", this.myValue);
		// 						this.$emit("change", this.myValue);
		// 					});
		// 				})
		// 				.catch(json => {
		// 					this.loading = false;
		// 					this.$message.error(json.data.msg);
		// 				});
		// 		})
		// 		.catch(() => {
		// 			this.myValue = {
		// 				_id: "",
		// 				name: ""
		// 			};
		// 			this.$message({
		// 				type: "info",
		// 				message: "已取消"
		// 			});
		// 		});
		// }
	},
	watch: {
		dataModelName: {
			handler(val) {
				this.dataModel = this.dataModelName;
			},
			immediate: true
		},
		filter: {
			handler(val) {
				this.filters = [{ k: "filter", t: "string", v: val }];
			},
			immediate: true
		}
	},
	components: {}
};
</script>
<style lang="scss" scoped>
</style>
